import type { AnyAction } from 'redux';

import { types } from './actions';

type Store = {
  modules: {
    common: { drawers: { nestingDefaultsDrawer: NestingDefaultsDrawerState } };
  };
};

export type NestingDefaultsDrawerState = {
  isOpen: boolean;
  isLinearNest: boolean;
};

const initialState = (): NestingDefaultsDrawerState => ({
  isOpen: false,
  isLinearNest: false,
});

const reducer = (state = initialState(), action: AnyAction) => {
  const { type, payload } = action;

  switch (type) {
    case types.OPEN_DRAWER:
      return {
        ...state,
        isOpen: true,
        isLinearNest: payload.isLinearNest,
      };
    case types.CLOSE_DRAWER:
      return initialState();
    default:
      return state;
  }
};

export default reducer;

const getScope = (state: Store) =>
  state.modules.common.drawers
    .nestingDefaultsDrawer as NestingDefaultsDrawerState;

export const isOpen = (state: Store) => getScope(state).isOpen;

export const isLinearNest = (state: Store) => getScope(state).isLinearNest;
